import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María',
  age: '34',
  location: 'Argentina',
  quote: 'Empecé a leerlo una noche que no podía dormir. No es un libro que te dice qué hacer, es un libro que te entiende. Lloré, pero de alivio.',
  color: 'bg-pink-100 text-pink-700'
}, {
  name: 'Carlos',
  age: '41',
  location: 'México',
  quote: 'Llevaba meses sintiéndome agotado sin razón. Este libro me ayudó a ponerle nombre a lo que me pasaba. Lo releo cada vez que necesito frenar.',
  color: 'bg-blue-100 text-blue-700'
}, {
  name: 'Valentina',
  age: '28',
  location: 'Colombia',
  quote: 'Pensé que era ansiedad, pero era algo más profundo. Este libro me hizo sentir que no estoy loca por sentir lo que siento.',
  color: 'bg-purple-100 text-purple-700'
}, {
  name: 'Diego',
  age: '45',
  location: 'España',
  quote: 'A los 45 empecé a cuestionar todo. Este libro no me dio respuestas, pero me dio algo mejor: permiso para hacer una pausa.',
  color: 'bg-orange-100 text-orange-700'
}, {
  name: 'Lucía',
  age: '37',
  location: 'Chile',
  quote: 'Soy mamá de dos y sentía que me estaba perdiendo. Este libro fue como una conversación honesta conmigo misma. Lo necesitaba.',
  color: 'bg-teal-100 text-teal-700'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-white" data-id="element-220">
      <div className="max-w-6xl mx-auto px-4" data-id="element-221">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-gray-900 mb-16" data-id="element-222">
          Historias de quienes ya lo leyeron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-223">
          {TESTIMONIALS.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} className="bg-gray-50 p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-224">
              <div className="flex items-center gap-1 mb-4" data-id="element-225">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-226" />)}
              </div>

              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-227">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-3" data-id="element-228">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${t.color}`} data-id="element-229">
                  {t.name.substring(0, 2).toUpperCase()}
                </div>
                <div data-id="element-230">
                  <p className="text-sm font-bold text-gray-900" data-id="element-231">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-232">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}